import styles from './PersonList.module.scss'
import {Person} from "@/types/person";
import {InteractionStats} from "@/types/interactionStats";
import PersonCard from "@/Molecules/Person/PersonCard";
import StickyContainer from "@/Molecules/StickyContainer/StickyContainer";
import Commercial, {CommercialType} from "@/Atoms/Commercial";
import {Fragment} from "react";
import useWindowSize from "@/helpers/useWindowSize";



export default (
  {
    obituaries
  }: {
  obituaries: []
}) => {


  const {isTablet, isMobile} = useWindowSize()


  return <StickyContainer
    component={<Commercial type={isTablet ? CommercialType.Leaderboard : CommercialType.HalfPageSkyscraper} top />}
  >
    <div className={styles.obituaries}>
      {obituaries.map((obituary: { person: Person, stats: InteractionStats }, index) => {

        // console.log(obituary.person)
        // const isLocked = ;
        return <Fragment key={index}>
          {/*{(index > 0 && index % 4 === 0 && isMobile) && <Commercial type={CommercialType.Leaderboard} className={styles.adBetween} />}*/}
          <PersonCard
            person={obituary.person}
          />
        </Fragment>
      })}
    </div>
  </StickyContainer>


}
